// A definition must be displayable, not just an entry key or an empty sense list.
function hasMeaning(senses){return Array.isArray(senses)&&senses.some(s=>s&&typeof s.text==='string'&&s.text.trim().length>0);}
function acceptedWords(words,entries){return words.filter(word=>hasMeaning(entries[word]));}
module.exports={hasMeaning,acceptedWords};
